import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PreferencesState {
  preferredCurrency: string;
  setPreferredCurrency: (currency: string) => void;
  preferredTimezone: string;
  setPreferredTimezone: (timezone: string) => void;
}

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set) => ({
      preferredCurrency: '',
      setPreferredCurrency: (currency) => set({ preferredCurrency: currency }),
      preferredTimezone: '',
      setPreferredTimezone: (timezone) => set({ preferredTimezone: timezone }),
    }),
    { name: 'pbf-portal-preferences' },
  ),
);
